import { take, call, put } from 'redux-saga/effects';
import * as types from '../../lib/actionTypes.es6';
import {
  getPartnerConfigs,
  getPartnerEmailConfigs,
  getEmailClients,
  getPartnerConfigsGroup,
  getPartnerConfigsClaim,

  updatePartner,
  updatePartnerConfig,
  updatePartnerConfigGroup,
  updatePartnerConfigClaim,
  updatePartnerConfigEmail,

  getSmsChannels,
  saveSmsChannel,
  deleteSmsChannel,
  testSmsChannel,
  upsertAllSmsChannels,
} from '../../lib/requests.es6';
import {
  getPolicyMakerChecks,
  createPolicyMakerCheck,
  updatePolicyMakerCheck,
  deletePolicyMakerCheck,
} from '../../lib/orgRequests.es6';
import * as actions from './actions.es6';
import { unAuthorizedNotification } from '../../lib/access.es6';
import { GAloggerException } from '../../lib/monitoring.es6';
import { getAllPartnersRequest } from '../Partners/actions.es6';


export function* getPartnerConfigsRequestWatcher() {
  for (; ;) {
    const request = yield take(types.GET_PARTNER_CONFIGS_REQUEST);
    try {
      const response = yield call(getPartnerConfigs, request.payload);
      yield put(actions.getPartnerConfigsSuccess(response.data));
    } catch (e) {
      let errorMessage = 'An unexpected error occurred';
      if (e.response) {
        errorMessage = e.response.data;
      }
      yield put(actions.getPartnerConfigsFailure(errorMessage));

      GAloggerException(e);
      unAuthorizedNotification(e);
    }
  }
}

export function* getPartnerEmailConfigsRequestWatcher() {
  for (; ;) {
    const request = yield take(types.GET_PARTNER_EMAIL_CONFIGS_REQUEST);
    try {
      const response = yield call(getPartnerEmailConfigs, request.payload);
      yield put(actions.getPartnerEmailConfigsSuccess(response.data));
    } catch (e) {
      let errorMessage = 'An unexpected error occurred';
      if (e.response) {
        errorMessage = e.response.data;
      }
      yield put(actions.getPartnerEmailConfigsFailure(errorMessage));

      GAloggerException(e);
      unAuthorizedNotification(e);
    }
  }
}

export function* getEmailClientsWatcher() {
  while (true) {
    yield take(types.GET_EMAIL_CLIENTS_REQUEST);
    try {
      const response = yield call(getEmailClients);
      yield put(actions.getEmailClientsSuccess(response.data));
    } catch (e) {
      let errorPayload = {};
      if (e.response) {
        errorPayload = e.response.data;
        unAuthorizedNotification(e);
      }
      yield put(actions.getEmailClientsFailure(errorPayload));
    }
  }
}

export function* getPartnerConfigsClaimRequestWatcher() {
  for (; ;) {
    const request = yield take(types.GET_PARTNER_CONFIGS_CLAIM_REQUEST);
    try {
      const response = yield call(getPartnerConfigsClaim, request.payload);
      yield put(actions.getPartnerConfigsClaimSuccess(response.data));
    } catch (e) {
      let errorMessage = 'An unexpected error occurred';
      if (e.response) {
        errorMessage = e.response.data;
      }
      yield put(actions.getPartnerConfigsClaimFailure(errorMessage));

      GAloggerException(e);
      unAuthorizedNotification(e);
    }
  }
}

export function* getPartnerConfigsGroupRequestWatcher() {
  for (; ;) {
    const request = yield take(types.GET_PARTNER_CONFIGS_GROUP_REQUEST);
    try {
      const response = yield call(getPartnerConfigsGroup, request.payload);
      yield put(actions.getPartnerConfigsGroupSuccess(response.data));
    } catch (e) {
      let errorMessage = 'An unexpected error occurred';
      if (e.response) {
        errorMessage = e.response.data;
      }
      yield put(actions.getPartnerConfigsGroupFailure(errorMessage));

      GAloggerException(e);
      unAuthorizedNotification(e);
    }
  }
}

export function* updatePartnerRequestWatcher() {
  for (; ;) {
    const request = yield take(types.UPDATE_PARTNER_REQUEST);
    console.log(request);

    try {
      const response = yield call(updatePartner, request.payload);
      yield put(actions.updatePartnerSuccess(response.data));
      yield put(getAllPartnersRequest());
      // start of test
      // yield fakeDelayToIndicateProgress()
      // yield put(actions.updatePartnerSuccess('done'));
      // yield put(actions.updatePartnerFailure('errorMessage'))
      // end of test
    } catch (e) {
      let errorMessage = 'An unexpected error occurred';
      if (e.response) {
        errorMessage = e.response.data;
      }
      yield put(actions.updatePartnerFailure(errorMessage));

      GAloggerException(e);
      unAuthorizedNotification(e);
    }
  }
}

export function* updatePartnerConfigRequestWatcher() {
  for (; ;) {
    const request = yield take(types.UPDATE_PARTNER_CONFIG_REQUEST);
    try {
      const response = yield call(updatePartnerConfig, request.payload);
      yield put(actions.updatePartnerConfigSuccess(response.data));
      // start of test
      // yield fakeDelayToIndicateProgress()
      // yield put(actions.updatePartnerConfigSuccess('done'));
      // yield put(actions.updatePartnerConfigFailure('errorMessage'));
      // end of test
    } catch (e) {
      let errorMessage = 'An unexpected error occurred';
      if (e.response) {
        errorMessage = e.response.data;
      }
      yield put(actions.updatePartnerConfigFailure(errorMessage));

      GAloggerException(e);
      unAuthorizedNotification(e);
    }
  }
}

export function* updatePartnerConfigEmailRequestWatcher() {
  for (; ;) {
    const request = yield take(types.UPDATE_PARTNER_CONFIG_EMAIL_REQUEST);
    try {
      const response = yield call(updatePartnerConfigEmail, request.payload);
      yield put(actions.updatePartnerConfigEmailSuccess(response.data));
    } catch (e) {
      let errorMessage = 'An unexpected error occurred';
      if (e.response) {
        errorMessage = e.response.data;
      }
      yield put(actions.updatePartnerConfigEmailFailure(errorMessage));

      GAloggerException(e);
      unAuthorizedNotification(e);
    }
  }
}

export function* updatePartnerConfigClaimRequestWatcher() {
  for (; ;) {
    const request = yield take(types.UPDATE_PARTNER_CONFIG_CLAIM_REQUEST);
    try {
      const response = yield call(updatePartnerConfigClaim, request.payload);
      yield put(actions.updatePartnerConfigClaimSuccess(response.data));
    } catch (e) {
      let errorMessage = 'An unexpected error occurred';
      if (e.response) {
        errorMessage = e.response.data;
      }
      yield put(actions.updatePartnerConfigClaimFailure(errorMessage));

      GAloggerException(e);
      unAuthorizedNotification(e);
    }
  }
}

export function* updatePartnerConfigGroupRequestWatcher() {
  for (; ;) {
    const request = yield take(types.UPDATE_PARTNER_CONFIG_GROUP_REQUEST);
    try {
      const response = yield call(updatePartnerConfigGroup, request.payload);
      yield put(actions.updatePartnerConfigGroupSuccess(response.data));
    } catch (e) {
      let errorMessage = 'An unexpected error occurred';
      if (e.response) {
        errorMessage = e.response.data;
      }
      yield put(actions.updatePartnerConfigGroupFailure(errorMessage));

      GAloggerException(e);
      unAuthorizedNotification(e);
    }
  }
}

export function* getPartnerSmsChannelsWatcher() {
  for (;;) {
    yield take(types.GET_PARTNER_SMS_CHANNELS_REQUEST);
    try {
      const response = yield call(getSmsChannels);
      yield put(actions.getPartnerSmsChannelsSuccess(response.data.data));
    } catch (e) {
      let errorMessage = 'An unexpected error occurred';
      if (e.response) {
        errorMessage = e.response.data;
      }
      yield put(actions.getPartnerSmsChannelsFailure(errorMessage));
      GAloggerException(e);
      unAuthorizedNotification(e);
    }
  }
}

export function* saveSmsChannelWatcher() {
  for (;;) {
    const request = yield take(types.SAVE_SMS_CHANNEL_REQUEST);
    try {
      const response = yield call(saveSmsChannel, request.payload);
      yield put(actions.saveSmsChannelSuccess(response.data));
      yield put(actions.getPartnerSmsChannelsRequest());
    } catch (e) {
      let errorMessage = 'An unexpected error occurred';
      if (e.response) {
        errorMessage = e.response.data;
      }
      yield put(actions.saveSmsChannelFailure(errorMessage));
      GAloggerException(e);
      unAuthorizedNotification(e);
    }
  }
}

export function* deleteSmsChannelWatcher() {
  for (;;) {
    const request = yield take(types.DELETE_SMS_CHANNEL_REQUEST);
    try {
      const response = yield call(deleteSmsChannel, request.payload);
      yield put(actions.deleteSmsChannelSuccess(response.data));
      yield put(actions.getPartnerSmsChannelsRequest());
    } catch (e) {
      let errorMessage = 'An unexpected error occurred';
      if (e.response) {
        errorMessage = e.response.data;
      }
      yield put(actions.deleteSmsChannelFailure(errorMessage));
      GAloggerException(e);
      unAuthorizedNotification(e);
    }
  }
}

export function* testSmsChannelWatcher() {
  for (;;) {
    const request = yield take(types.TEST_SMS_CHANNEL_REQUEST);
    try {
      const response = yield call(testSmsChannel, request.payload);
      yield put(actions.testSmsChannelSuccess(response.data));
    } catch (e) {
      let errorMessage = 'An unexpected error occurred';
      if (e.response) {
        errorMessage = e.response.data;
      }
      yield put(actions.testSmsChannelFailure(errorMessage));
    }
  }
}

export function* saveChannelResolutionWatcher() {
  for (;;) {
    const request = yield take(types.SAVE_CHANNEL_RESOLUTION_REQUEST);
    try {
      const response = yield call(upsertAllSmsChannels, request.payload);
      yield put(actions.saveChannelResolutionSuccess(response.data));
      yield put(actions.getPartnerSmsChannelsRequest());
    } catch (e) {
      let errorMessage = 'An unexpected error occurred';
      if (e.response) {
        errorMessage = e.response.data;
      }
      yield put(actions.saveChannelResolutionFailure(errorMessage));
      GAloggerException(e);
      unAuthorizedNotification(e);
    }
  }
}

export function* getPolicyMakerChecksWatcher() {
  for (;;) {
    yield take(types.GET_POLICY_MAKER_CHECKS_REQUEST);
    try {
      const response = yield call(getPolicyMakerChecks);
      yield put(actions.getPolicyMakerChecksSuccess(response.data));
    } catch (e) {
      let errorMessage = 'An unexpected error occurred';
      if (e.response) {
        errorMessage = e.response.data;
      }
      yield put(actions.getPolicyMakerChecksFailure(errorMessage));
      GAloggerException(e);
      unAuthorizedNotification(e);
    }
  }
}

export function* savePolicyMakerCheckWatcher() {
  for (;;) {
    const request = yield take(types.SAVE_POLICY_MAKER_CHECK_REQUEST);
    try {
      const payload = request.payload || {};
      const guid = payload.guid;
      const body = {
        type: payload.type,
        label: payload.label,
        sequence: payload.sequence,
        allow_to_skip: payload.allow_to_skip,
      };
      let response;
      if (guid) {
        response = yield call(updatePolicyMakerCheck, guid, body);
      } else {
        response = yield call(createPolicyMakerCheck, body);
      }
      yield put(actions.savePolicyMakerCheckSuccess(response.data));
      yield put(actions.getPolicyMakerChecksRequest());
    } catch (e) {
      let errorMessage = 'An unexpected error occurred';
      if (e.response) {
        errorMessage = e.response.data;
      }
      yield put(actions.savePolicyMakerCheckFailure(errorMessage));
      GAloggerException(e);
      unAuthorizedNotification(e);
    }
  }
}

export function* deletePolicyMakerCheckWatcher() {
  for (;;) {
    const request = yield take(types.DELETE_POLICY_MAKER_CHECK_REQUEST);
    try {
      const response = yield call(deletePolicyMakerCheck, request.payload);
      yield put(actions.deletePolicyMakerCheckSuccess(response.data));
      yield put(actions.getPolicyMakerChecksRequest());
    } catch (e) {
      let errorMessage = 'An unexpected error occurred';
      if (e.response) {
        errorMessage = e.response.data;
      }
      yield put(actions.deletePolicyMakerCheckFailure(errorMessage));
      GAloggerException(e);
      unAuthorizedNotification(e);
    }
  }
}

// const delay = ms => new Promise(res => setTimeout(res, ms));
// const fakeDelayToIndicateProgress = async () => {
//   await delay(2000);
//   console.log("Waited 2s");
// };